import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
	root: {
		alignSelf: 'stretch'
	},
}));